import { render, staticRenderFns } from "./OurStory.vue?vue&type=template&id=46fe9c10&scoped=true"
var script = {}
import style0 from "./OurStory.vue?vue&type=style&index=0&id=46fe9c10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fe9c10",
  null
  
)

export default component.exports